import { useEffect, useState } from 'react';
import { useStore } from '@/contexts/StoreContext';
import { apiClient } from '@/lib/api/client';

export type ComandoDoJogo = 'vip' | 'tempovip' | 'loja' | 'vincular' | 'resgatar' | 'darvip' | 'removervip' | 'congelarvip';
type Comandos = Record<ComandoDoJogo, string>;

const PADRAO: Comandos = {
  vip: '/vip',
  tempovip: '/tempovip',
  loja: '/loja',
  vincular: '/vincular',
  resgatar: '/resgatar',
  darvip: '/darvip',
  removervip: '/removervip',
  congelarvip: '/congelarvip',
};

/** Uma leitura por loja (os textos de várias telas usam). */
const cache = new Map<string, Promise<Comandos>>();

/**
 * Os comandos do plugin com o nome que o lojista deu no painel (Plugin >
 * Permissões e comandos), para os textos da vitrine ("use /vip") baterem com
 * o que o jogador digita no servidor. Sem resposta, os nomes padrão.
 */
export function useComandosDoJogo(): Comandos {
  const { store } = useStore();
  const [comandos, setComandos] = useState<Comandos>(PADRAO);
  useEffect(() => {
    if (!store?.id) return;
    let promessa = cache.get(store.id);
    if (!promessa) {
      promessa = apiClient
        .get<{ commands: Partial<Comandos> }>(`/public/stores/${store.id}/plugin-commands`)
        .then((r) => ({ ...PADRAO, ...(r.commands ?? {}) }))
        .catch(() => PADRAO);
      cache.set(store.id, promessa);
    }
    let vivo = true;
    void promessa.then((c) => {
      if (vivo) setComandos(c);
    });
    return () => {
      vivo = false;
    };
  }, [store?.id]);
  return comandos;
}
